import React, { useState } from 'react';

import { TemplateField } from '../../_types';
import FieldTypeDisplay from 'views/App/Portal/PerformanceReporting/_components/FieldInputs/FieldTypeDisplay';

interface TemplateFieldPreviewProps {
  field: TemplateField;
  isInteractive?: boolean;
}

const TemplateFieldPreview: React.FC<TemplateFieldPreviewProps> = ({ field, isInteractive = false }) => {
  const [localValues, setLocalValues] = useState<string[]>(field.effectiveDefaultValues ?? []);

  if (isInteractive) {
    return (
      <FieldTypeDisplay
        field={{ ...field, effectiveDefaultValues: localValues }}
        disabled={false}
        isBuilderCard={false}
        size='medium'
        onChange={setLocalValues}
      />
    );
  }

  return (
    <FieldTypeDisplay
      field={field}
      disabled={true}
      isBuilderCard={false}
      size='medium'
    />
  );
};

export default TemplateFieldPreview;
